import * as React from 'react';
import { InjectedRouter, PlainRoute } from 'react-router';

import AdminOrganizationSettingsContainer from './AdminOrgApprovalSettingsContainer';
import AdminOrganizationSettingsView from './AdminOrgApprovalSettingsView';
import { OrganizationType } from 'globalTypes';
import { withRouter } from 'app/context/Router';

type Props = {
  organizationUUID: string;
  orgId: string;
  orgType: OrganizationType;
  route: PlainRoute;
  router: InjectedRouter;
};

function AdminOrganizationSettings(props: Props) {
  const { organizationUUID, route, router } = props;

  return (
    <AdminOrganizationSettingsContainer organizationUUID={organizationUUID}>
      {({ approvalSettings, onSave }) => {
        return (
          <AdminOrganizationSettingsView
            approvalSettings={approvalSettings}
            onSave={onSave}
            orgUuid={organizationUUID}
            route={route}
            router={router}
          />
        );
      }}
    </AdminOrganizationSettingsContainer>
  );
}

export { AdminOrganizationSettings };
export default withRouter(AdminOrganizationSettings);
